import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=1415d742&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415d742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1415d742')) {
      api.createRecord('1415d742', component.options)
    } else {
      api.reload('1415d742', component.options)
    }
    module.hot.accept("./publish.vue?vue&type=template&id=1415d742&scoped=true", function () {
      api.rerender('1415d742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/protocolCompliance/protocolUpdate/components/publish.vue"
export default component.exports